<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'menuitem.order-pickup-add' | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">

      <app-customer-info-widget [customer]="customerDetailDto.customer" [address]="customerDetailDto.address">

      </app-customer-info-widget>

    </div>
    <!-- Sipariş Özeti başlangıç -->
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <div class="card">
        <!-- <div class="card-header">
          <h5>{{'title.order-summary' | translate}}</h5>
        </div> -->
        <div class="card-body">
          <form #orderForm="ngForm" class="needs-validation" novalidate>

            <div class="row form-group" *ngIf="stores.length > 1">
              <div class="col-sm-12">
                <label class="custom-form-label">{{'store.storeName' | translate}}</label>
              </div>
              <div class="col-sm-12">
                <select #store name="store" class="form-control input-lg" [(ngModel)]="order.storeId" (ngModelChange)="onChangeStore()" required>
                  <option *ngFor="let item of stores" [ngValue]="item.id">{{ item.name }}
                  </option>
                </select>
              </div>

              <app-field-error-display class="col-sm-12" [displayError]="store.invalid && store.touched" errorMsg="Please inform your store">
              </app-field-error-display>
            </div>


            <div class="row form-group" *ngIf="serviceCars.length > 1">
              <div class="col-sm-12">
                <label class="custom-form-label">{{'serviceCar.name' | translate}}</label>
              </div>
              <div class="col-sm-12">
                <select #serviceCar name="serviceCar" class="form-control input-lg" [(ngModel)]="order.serviceCarId" required>
                  <option *ngFor="let item of serviceCars" [ngValue]="item.id">{{ item.name }}
                  </option>
                </select>
              </div>

              <app-field-error-display class="col-sm-12" [displayError]="serviceCar.invalid && serviceCar.touched" errorMsg="Please inform your serviceCar">
              </app-field-error-display>
            </div>


            <!-- Alım Tarihi -->
            <div class="row form-group">
              <div class="col-sm-12">
                <label class="custom-form-label">{{'order.pickupDate' | translate}}</label>
              </div>
              <div class="col-sm-8">
                <p-calendar name="pickupDate" [(ngModel)]="order.pickupDate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [dateFormat]="dateFormatEnum.DATE_TIME_PICKER_INPUT_FORMAT"
                  [showTime]="true" [firstDayOfWeek]="'firstDayOfWeek'| translate">
                </p-calendar>
              </div>
            </div>
            <!-- Not -->
            <div class="row form-group">
              <div class="col-sm-12">
                <label class="custom-form-label">{{'order.notes' | translate}}</label>
              </div>
              <div class="col-sm-12">
                <div class="input-group">
                  <textarea class="form-control" name="notes" [(ngModel)]="order.notes" placeholder="Sipariş Notu" rows="1"></textarea>
                  <button class="btn btn-primary" type="button" (click)="openSelectOrderNote()">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- Adres -->
            <div class="row form-group">
              <div class="col-sm-12">
                <label class="custom-form-label">{{'address.description' | translate}}</label>
              </div>

              <div class="input-group col-sm-12">
                <textarea type="text" #addressDescription="ngModel" name="addressDescription" [(ngModel)]="address.description" class="form-control" readonly>
                </textarea>
                <div class="input-group-append d-flex flex-column">
                  <button class="btn btn-sm btn-primary btn-input-group-append" type="button" (click)="openUpdateAddress()"> {{'button.update' | translate}}</button>
                  <button class="btn btn-sm btn-outline-primary btn-input-group-append" type="button" (click)="chooseAddress()"> {{'button.select' | translate}}</button>
                </div>
              </div>
            </div>
            <div class="form-check form-switch">
              <input name="isPrintReceipt" type="checkbox" class="form-check-input" id="chkReceipt" [(ngModel)]="isPrintReceipt" />
              <label class="form-check-label" for="chkReceipt">{{'confirmation.isPrintReceipt' | translate}}</label>

            </div>

            <div class="form-check form-switch">
              <input name="isSendSmsInput" type="checkbox" class="form-check-input" id="isSendSmsInput" checked="" [(ngModel)]="isSendSms" />
              <label class="form-check-label" for="isSendSmsInput">{{'confirmation.isSendSms' | translate}}</label>
            </div>

            <div class="form-check form-switch">
              <input name="isSendSmsForServiceCarInput" type="checkbox" class="form-check-input" id="isSendSmsForServiceCarInput" checked="" [(ngModel)]="isSendSmsForServiceCar" />
              <label class="form-check-label" for="isSendSmsForServiceCarInput">{{'confirmation.isSendSmsForServiceCar' | translate}}</label>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>
  <button class="btn btn-primary" [disabled]="isBusy" type="submit" (click)="save()">
    <i [hidden]="!isBusy" class="fa fas fa-circle-notch fa-spin"></i>
    <span [hidden]="isBusy"> {{'button.save' | translate}}</span>
    <span [hidden]="!isBusy"> {{'progress.please-wait' | translate}}</span>
  </button>
</div>